import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    AccentButton,
    StyledModal,
    StyledAlertMarginTop,
} from '../../../styles/common';
import {
    StyledHeader,
    StyledBody,
    StyledFooter,
    ModalText,
    ModalWarningText,
} from '../../tabLibrary/HelpDesk/Users/styles';
import { deleteData } from '../../../utils/deleteData';

const UserIdVerificationDelete = ({ onClose, data, ...otherProps }) => {
    const { t } = useTranslation();
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteError, setDeleteError] = useState('');
    const [deleteSuccess, setDeleteSuccess] = useState('');

    const handleDeleteIdv = async () => {
        setIsDeleting(true);
        setDeleteError('');
        setDeleteSuccess('');

        try {
            const res = await deleteData({
                endpoint: `/user/${data.username}/verification`,
            });

            if (res.ok) {
                console.log('reaching in success response');
                setDeleteSuccess(t('idv$delete$success'));
                setTimeout(() => {
                    setDeleteSuccess('');
                    if (onClose) {
                        onClose({ submit: true });
                    }
                }, 2000);
            } else {
                const json = await res.json();
                let errorMsg = t('idv$delete$error$default');

                if (res.status === 400) {
                    errorMsg = json?.message || t('idv$delete$error$notAllowed');
                } else if (res.status === 404) {
                    errorMsg = json?.message || t('idv$delete$error$notFound');
                } else if (json?.message) {
                    errorMsg = json.message;
                }

                setDeleteError(errorMsg);
            }
        } catch (error) {
            console.error('Error deleting IDV data:', error);
            setDeleteError(t('idv$delete$error$default'));
        } finally {
            setIsDeleting(false);
        }
    };

    const closeModal = () => {
        if (!isDeleting) {
            onClose({ submit: false });
        }
    };

    const fullName =
        [data.firstName, data.lastName].filter((name) => name).join(' ') || '';

    return (
        <StyledModal
            centered
            size="lg"
            isOpen={true}
            toggle={closeModal}
            backdrop={isDeleting ? 'static' : true}
            {...otherProps}
        >
            <StyledHeader>{t('idv$delete$modal$title')}</StyledHeader>
            <StyledBody>
                <ModalText>
                    {t('idv$delete$modal$message', {
                        username: data.username,
                        fullName: fullName,
                    })}
                </ModalText>
                <ModalWarningText>
                    {t('idv$delete$modal$warning')}
                </ModalWarningText>
                {deleteSuccess && (
                    <StyledAlertMarginTop color="success" role="alert">
                        {deleteSuccess}
                    </StyledAlertMarginTop>
                )}
                {deleteError && (
                    <StyledAlertMarginTop color="danger" role="alert">
                        {deleteError}
                    </StyledAlertMarginTop>
                )}
            </StyledBody>
            <StyledFooter>
                <AccentButton
                    outline
                    color="danger"
                    size="sm"
                    onClick={handleDeleteIdv}
                    disabled={isDeleting}
                >
                    {isDeleting
                        ? t('idv$delete$modal$deleting')
                        : t('modalElementLabels$modal$confirm')}
                </AccentButton>
                <AccentButton
                    outline
                    color="primary"
                    size="sm"
                    onClick={closeModal}
                    disabled={isDeleting}
                >
                    {t('modalElementLabels$modal$cancel')}
                </AccentButton>
            </StyledFooter>
        </StyledModal>
    );
};

export default UserIdVerificationDelete;
